// extracted by mini-css-extract-plugin
module.exports = {"formDiy":"index__formDiy__vGpf0"};